import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { VideoEmbed } from 'components/common/VimeoEmbed/VideoEmbed';

import './video-and-description.scss';

type VideoAndDescriptionProps = {
  src: string;
  title: string;
  header: string;
  description: string;
  readMoreLink?: string;
};

// TODO: on hover, translate arrow to the right
export function VideoAndDescription(props: VideoAndDescriptionProps): JSX.Element {
  const { src, title, header, description, readMoreLink } = props;
  return (
    <Flex className="video-and-description" direction="column" gap="lg">
      <VideoEmbed src={src} title={title} />
      <Flex className="video-and-description-header" direction="column" gap="md">
        <Typography variant="subtitle">{header}</Typography>
        <Typography variant="caption">{description}</Typography>
        {readMoreLink && (
          <Typography variant="caption">
            <a href={readMoreLink} target="_blank" rel="noopener noreferrer">
              Read more <span className="read-more-arrow">↑</span>
            </a>
          </Typography>
        )}
      </Flex>
    </Flex>
  );
}
